// redux/store.js
import { configureStore } from '@reduxjs/toolkit';
import rootReducer from '../reducers';
import { persistStore, persistReducer } from 'redux-persist';
// Use session storage instead of localStorage
import storage from 'redux-persist/lib/storage/session';
import {
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';

const persistConfig = {
  key: 'root',
  storage, // Now uses sessionStorage which clears on browser tab close
  whitelist: ['auth'], // Persist only the auth slice, adjust as needed
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore new redux-persist actions
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
  devTools: process.env.NODE_ENV !== 'production',
});

export const persistor = persistStore(store);
export default store;
